"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._AllowedHeaders = {
    type: "list",
    flattened: true,
    member: {
        shape: {
            type: "string"
        }
    }
};
//# sourceMappingURL=_AllowedHeaders.js.map